import * as React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

export default function StatusCard({
  text,
  color,
  type,
}: {
  text: string;
  color?: string;
  type?: string;
}) {
  return (
    <Stack spacing={1} sx={{ alignItems: 'center' }}>
      <Stack direction="row" spacing={1}>
       <Chip label={text} color={color as any} variant="outlined" style={{backgroundColor:color,padding:'0px'}} className='p-0'/> 
      </Stack>
    </Stack>
  );
}